import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Card } from '@febos-io/design';

import { getCompanies, setUserClinic } from '../store';

import { useAuthContext } from '../providers';

import useTranslation from '../hooks/useTranslation';
import { store } from '..';
import {COMPANY_SELECTOR} from '../config';

export function ClinicSelector() {
  const [clinicsOptions, setClinicsOptions] = useState(undefined);

  const { t, } = useTranslation();
  const companies = useSelector(getCompanies);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { signInRedirectPathname, } = useAuthContext();
  const companyId = useSelector(store.getCompanyId);

  const onClinicSelect = (clinic) => {
    dispatch(setUserClinic(clinic));
    localStorage.setItem('clinic-relation', clinic.clinicId);
    navigate(signInRedirectPathname);
  };

  const handleBackToSelectCompany = () => {
    navigate(COMPANY_SELECTOR);
  };

  useEffect(() => {
    const clinics = companies.find(
      (company) => company.company.companyId === companyId
    )?.clinics;

    if (clinics.length === 1) {
      dispatch(setUserClinic(clinics[0]));
      localStorage.setItem('clinic-relation', clinics[0].clinicId);
      navigate(signInRedirectPathname);
    } else {
      setClinicsOptions(clinics);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="list-group">
      {clinicsOptions?.map((clinic) => (
        <Card
          key={clinic.clinicId}
          onClick={() => onClinicSelect(clinic)}
          className="cursor-pointer card-hover"
        >
          <>
            <h3>{clinic.name}</h3>
            <p className="mb-0">{clinic.identification}</p>
          </>
        </Card>
      ))
      }
      {companies.length > 1 && (
        <Button
          onClick={handleBackToSelectCompany}
        >
          {t('Go to select company')}
        </Button>
      )}
    </div>
  );
}

export default ClinicSelector;
